import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '@/navigation/routes.tsx';
import Protected from '@/navigation/Protected.tsx';
import ErrorWrapper from '@/components/common/ErrorWrapper/ErrorWrapper.tsx';
import IndexPage from '@/pages/IndexPage/IndexPage.tsx';
import Page403 from '@/pages/CodeErrors/Page403.tsx';
import DeletedProfile from '@/components/Verification/DeletedProfile.tsx';
import BannedProfile from '@/components/Verification/BannedProfile.tsx';
import Search from '@/pages/Search/Search.tsx';
import Messenger from '@/pages/Messenger/Messenger.tsx';
import Likes from '@/pages/Likes/Likes.tsx';
import Profile from '@/pages/Profile/Profile.tsx';
import EditProfile from '@/pages/Profile/Edit/EditProfile.tsx';
import ProfileSettings from '@/pages/Profile/Settings/ProfileSettings.tsx';
import EarnTon from '@/pages/Earn/EarnTon.tsx';
import WithdrawTon from '@/pages/Earn/WithdrawTon.tsx';
import SelectLocale from '@/pages/Profile/Settings/Locale/Locale.tsx';
import Notifications from '@/pages/Profile/Settings/Notifications/Notifications.tsx';
import Privacy from '@/pages/Profile/Settings/Privacy/Privacy.tsx';
import Layout from '@/components/Layout/Layout.tsx';
import RegistrationUserData from '@/pages/Registration/RegistrationUserData.tsx';
import RegistrationUserPhotos from '@/pages/Registration/RegistrationUserPhotos.tsx';
import RegistrationUserSelfie from '@/pages/Registration/RegistrationUserSelfie.tsx';
import Account from '@/pages/Profile/Settings/Account/Account.tsx';
import WithdrawTonDetails from '@/pages/Earn/WithdrawTonDetails.tsx';
import WithdrawTonSuccess from '@/pages/Earn/WithdrawTonSuccess.tsx';
import RegistrationWelcomePage from '@/pages/Registration/RegistrationWelcomePage.tsx';
import HideAccount from '@/pages/Profile/Settings/Account/HideAccount/HideAccount.tsx';
import Support from '@/pages/Profile/Settings/Support/Support.tsx';
import { RegistrationRoute } from '@/navigation/RegistrationRoute.tsx';
import VerificationFailed from '@/components/Verification/VerificationFailed.tsx';
import Chat from '@/pages/Messenger/Chat.tsx';
import HeaderLayout from '@/components/Layout/HeaderLayout.tsx';

const Router = () => (
  <>
    <HeaderLayout />
    <Routes>
      {[
        { path: routes.login, element: <IndexPage /> },
        { path: routes.accessDenied, element: <Page403 /> },
        { path: routes.deletedProfile, element: <DeletedProfile /> },
        { path: routes.banned, element: <BannedProfile /> },
        { path: routes.verificationFailed, element: <VerificationFailed /> }
      ].map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={<ErrorWrapper>{element}</ErrorWrapper>}
        />
      ))}

      <Route element={<RegistrationRoute />}>
        {[
          {
            path: routes.registrationWelcomePage,
            element: <RegistrationWelcomePage />
          },
          {
            path: routes.registrationUserData,
            element: <RegistrationUserData />
          },
          {
            path: routes.registrationUserPhotos,
            element: <RegistrationUserPhotos />
          },
          {
            path: routes.registrationUserSelfie,
            element: <RegistrationUserSelfie />
          }
        ].map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<ErrorWrapper>{element}</ErrorWrapper>}
          />
        ))}
      </Route>

      <Route
        path={routes.index}
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Navigate to={routes.search} />} />
        <Route path={routes.search} element={<Search />} />
        <Route path={routes.likes} element={<Likes />} />
        <Route path={routes.messenger} element={<Messenger />} />
        <Route path={routes.profile} element={<Profile />} />
      </Route>

      {[
        { path: routes.chat, element: <Chat /> },
        { path: routes.profileSettings, element: <ProfileSettings /> },
        { path: routes.selectLocale, element: <SelectLocale /> },
        { path: routes.profileNotifications, element: <Notifications /> },
        { path: routes.profilePrivacy, element: <Privacy /> },
        { path: routes.profileAccount, element: <Account /> },
        { path: routes.profileHideAccount, element: <HideAccount /> },
        { path: routes.support, element: <Support /> },
        { path: routes.profileEdit, element: <EditProfile /> },
        { path: routes.earnTon, element: <EarnTon /> },
        { path: routes.withdrawTon, element: <WithdrawTon /> },
        { path: routes.withdrawTonDetails, element: <WithdrawTonDetails /> },
        { path: routes.withdrawTonSuccess, element: <WithdrawTonSuccess /> }
      ].map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={<Protected>{element}</Protected>}
        />
      ))}

      <Route path="*" element={<Navigate to={routes.login} />} />
    </Routes>
  </>
);

export default Router;
